// extracted by mini-css-extract-plugin
module.exports = {"element":"heading_element__3FLwA"};